import { render } from "./AssetPickerComponentSettings.vue?vue&type=template&id=6240c68e&scoped=true&ts=true"
import script from "./AssetPickerComponentSettings.vue?vue&type=script&lang=ts"
export * from "./AssetPickerComponentSettings.vue?vue&type=script&lang=ts"

import "./AssetPickerComponentSettings.vue?vue&type=style&index=0&id=6240c68e&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6240c68e"]])

export default __exports__